// Copyright (c) 2026 PGNS LLC
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

import type { SVGProps } from 'react';

export function PgnsLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 10 59 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {/* Input line */}
      <path d="M 8 32 L 24 32" stroke="#D4915C" strokeWidth={5} strokeLinecap="round" />
      {/* Output path: top (purple) */}
      <path d="M 32 32 L 52 16" stroke="#9B72CF" strokeWidth={4} strokeLinecap="round" />
      {/* Output path: bottom (blue) */}
      <path d="M 32 32 L 52 48" stroke="#3B7FA8" strokeWidth={4} strokeLinecap="round" />
      {/* Output path: middle (green, on top of purple and blue) */}
      <path d="M 32 32 L 56 32" stroke="#2D9B8A" strokeWidth={4} strokeLinecap="round" />
      {/* Node (on top of all lines) */}
      <circle cx={28} cy={32} r={5} fill="#D4915C" />
      {/* Endpoint: top */}
      <circle cx={52} cy={16} r={4} fill="#9B72CF" />
      {/* Endpoint: middle */}
      <circle cx={56} cy={32} r={4} fill="#2D9B8A" />
      {/* Endpoint: bottom */}
      <circle cx={52} cy={48} r={4} fill="#3B7FA8" />
    </svg>
  );
}
